import { render } from "./PointWidget.vue?vue&type=template&id=612f47fb"
import script from "./PointWidget.vue?vue&type=script&lang=js"
export * from "./PointWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__